<script setup>
  import StormSelectionButtonBase from "@/components/StormSelectionButtonBase.vue";
  import useSettingsGlobals from '@/composables/useSettingsGlobals';

  const {
    $WEB_VIEW,
    $PLATFORM
  } = useSettingsGlobals();  

  const props = defineProps({
    storm: {
      type: Object,
      required: true
    }
  });

  function handleStormChange(e) {
    const button = e.target.closest('button');
    const id = button.id;

    if ($WEB_VIEW) {
      const info = {
        type: "storm-id",
        storm_id: id
      };

      if ($PLATFORM === "android") {
        const params = [
          info.type,
          info.storm_id
        ];

        alert(params.join(","));
      } else {
        window.webkit.messageHandlers.observe.postMessage(info);
      }

      return;
    }

    const url = window.location.href;
    const newUrl = new URL(url);
    const pathname = 'en-us/Storms/storm.aspx';
    window.location = `${newUrl.origin}/${pathname}?storm_id=${id}`;
  }
</script>

<template>
  <StormSelectionButtonBase
    @click.prevent="handleStormChange"
    :allEnabled="true"
    :storm="props.storm"
    :showActive="false"
    :showToggle="false"
  />
</template>